import { AdminDialog } from './admin-dialog';
export default AdminDialog;
